import CourseListParcel from "../api/endpoints/course/CourseListParcel";
import useRecord from "./useRecord";

export default function useCourse(idOrSlug, refNames) {
    return useRecord(CourseListParcel, idOrSlug, refNames);
}
